import * as React from "react"
import styles from "./SendButton.module.scss"

import { SendButtonProps } from "stream-chat-react"

const SendButton: React.FC<SendButtonProps> = (props) => {
	const disabledClass = props.disabled ? styles.disabled : ""

	return (
		<div
			className={`${styles.send_button} ${props.className || ""} ${disabledClass}`}
			onClick={props.sendMessage}
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
			>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 16L11 12L8 12L12 8L16 12L13 12L13 16L11 16Z"
				/>
			</svg>
		</div>
	)
}

export default React.memo(SendButton)
